var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gallery_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "gallery_svg__icon",
    d: "M24.588 1.5H5.216A2.243 2.243 0 002.98 3.75v.75h-.745A2.243 2.243 0 000 6.75v13.5c0 1.243 1 2.25 2.235 2.25h19.373a2.243 2.243 0 002.235-2.25v-.75h.745a2.243 2.243 0 002.235-2.25V3.75c0-1.243-1-2.25-2.235-2.25zm-2.235 18.75c0 .413-.334.75-.745.75H2.235a.748.748 0 01-.745-.75V6.75c0-.414.334-.75.745-.75h.745v11.25c0 1.243 1.001 2.25 2.236 2.25h17.137v.75zm2.98-3c0 .413-.334.75-.745.75H5.216a.748.748 0 01-.745-.75V3.75c0-.414.334-.75.745-.75h19.372c.411 0 .745.336.745.75v13.5zM8.196 9.375a2.616 2.616 0 002.608-2.625 2.616 2.616 0 00-2.608-2.625A2.616 2.616 0 005.588 6.75a2.616 2.616 0 002.608 2.625zm0-3.75c.616 0 1.118.505 1.118 1.125s-.502 1.125-1.118 1.125A1.123 1.123 0 017.078 6.75c0-.62.502-1.125 1.118-1.125zm11.222 1.08a1.112 1.112 0 00-1.58 0l-4.426 4.454-1.445-1.455a1.112 1.112 0 00-1.58 0L6.287 13.83c-.21.211-.327.498-.327.796v1.313c0 .31.25.562.559.562h16.764a.56.56 0 00.56-.563v-4.312c0-.298-.119-.585-.328-.796l-4.098-4.125zM22.353 15H7.45v-.22l3.726-3.75 2.235 2.25 5.216-5.25 3.725 3.75V15z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gallery_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26.823v24H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/gallery.b617634a94af8b2abdede3142fce2bd8.svg";
export { SvgGallery as ReactComponent };